import { useAuth } from '@/shared/context'
import { selectUserInfo } from '@/shared/redux/slices/appGlobal.slice'
import { useSelector } from 'react-redux'

/**
 * Hook trả về userId của người dùng hiện tại (nếu đã đăng nhập).
 * Ưu tiên lấy từ Redux store (userInfo), fallback sang AuthContext (user).
 * Trả về string hoặc undefined.
 */
export const useCurrentUserId = (): string | undefined => {
  const userInfo = useSelector(selectUserInfo) as
    | { id?: string; userId?: string }
    | null
    | undefined
  const { user } = useAuth()

  const id = userInfo?.id || userInfo?.userId || user?.id
  return id ? String(id) : undefined
}
